import React from 'react';
import { HexColorInput, HexAlphaColorPicker } from 'react-colorful';
import getSelectField from '../../fields/select';
import toggleColorPicker from '../../../Functions/toggleColorPicker';

const Container = ({ widget, handleInputChange, setColorsAndPreview }) => {
    const { affordability } = widget.htmlData;

    // Updated shadow options with more pronounced effects
   const shadowOptions = [
        { value: 'none', label: 'No Shadow' },
        { value: 'sm', label: 'Small Shadow' },
        { value: 'md', label: 'Medium Shadow' },
        { value: 'lg', label: 'Large Shadow' },
        { value: 'xl', label: 'Extra Large Shadow' },
        { value: 'xxl', label: 'Double Extra Large Shadow' },
        { value: 'inner', label: 'Inner Shadow' }
    ];

    const shadowValues = {
        none: 'none',
        sm: '0 2px 4px rgba(0,0,0,0.15)', 
        md: '0 6px 12px rgba(0,0,0,0.25)', 
        lg: '0 10px 20px rgba(0,0,0,0.3)', 
        xl: '0 15px 30px rgba(0,0,0,0.35)',
        xxl: '0 20px 40px rgba(0,0,0,0.4)',
        inner: 'inset 0 4px 8px rgba(0,0,0,0.2)' 
    };

    // Determine the current shadow type based on the stored shadow value
    const currentShadow = affordability.container.shadow || shadowValues.none;
    const intensity = Object.keys(shadowValues).find(key => shadowValues[key] === currentShadow) || 'none';

    return (
        <div className="mjwi-acc-panel-wrapper">
            <div className="mjwi-row">
                <div className="mjwi-col50">
                    <label>Background Color</label>
                </div>
                <div className="mjwi-col66 mjwi-clr-picker">
                    <span
                        className="clrPickerVal"
                        style={{ backgroundColor: affordability.container.bgColor }}
                        onClick={toggleColorPicker}
                    ></span>
                    <HexAlphaColorPicker
                        color={affordability.container.bgColor}
                        onChange={(color) => setColorsAndPreview('container', 'bgColor', color)}
                        style={{ display: 'none' }}
                        className="mjwi-apfl-color-picker"
                    />
                    <HexColorInput
                        color={affordability.container.bgColor}
                        onChange={(color) => setColorsAndPreview('container', 'bgColor', color)}
                    />
                </div>
            </div>
            <div className="mjwi-row">
                <div className="mjwi-col50">
                    <label>Border Color</label>
                </div>
                <div className="mjwi-col66 mjwi-clr-picker">
                    <span
                        className="clrPickerVal"
                        style={{ backgroundColor: affordability.container.borderColor }}
                        onClick={toggleColorPicker}
                    ></span>
                    <HexAlphaColorPicker
                        color={affordability.container.borderColor}
                        onChange={(color) => setColorsAndPreview('container', 'borderColor', color)}
                        style={{ display: 'none' }}
                        className="mjwi-apfl-color-picker"
                    />
                    <HexColorInput
                        color={affordability.container.borderColor}
                        onChange={(color) => setColorsAndPreview('container', 'borderColor', color)}
                    />
                </div>
            </div>
            <div className="mjwi-row">
                <div className="mjwi-col50">
                    <label>Shadow</label>
                </div>
                <div className="mjwi-col50">
                    {getSelectField(
                        'shadow',
                        shadowOptions.map(opt => opt.label),
                        shadowOptions.find(opt => opt.value === intensity)?.label || 'None',
                        (e) => {
                            const selectedValue = shadowOptions.find(opt => opt.label === e.target.value)?.value;
                            handleInputChange({ target: { name: 'shadow', value: shadowValues[selectedValue] } }, ['container']);
                        }
                    )}
                </div>
            </div>
            <div className="mjwi-row">
                <div className="mjwi-col50 mjwi-row">
                    <label>Border Radius</label>
                </div>
                <div className="mjwi-col33">
                    <div className="mjwi-size-input">
                        <input
                            type="number"
                            name="borderRadius"
                            value={parseFloat(affordability.container.borderRadius) || ''}
                            onChange={(e) => handleInputChange({ target: { name: 'borderRadius', value: `${e.target.value}px` } }, ['container'])}
                            className="mjwi-input"
                            min="0"
                        />
                    </div>
                </div>
            </div>
            <div className="mjwi-row">
                <div className="mjwi-col50 mjwi-row">
                    <label>Padding</label>
                </div>
                <div className="mjwi-col33">
                    <div className="mjwi-size-input">
                        <input
                            type="number"
                            name="padding"
                            value={parseFloat(affordability.container.padding) || ''}
                            onChange={(e) => handleInputChange({ target: { name: 'padding', value: `${e.target.value}px` } }, ['container'])}
                            className="mjwi-input"
                            min="0"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Container;